import { Row, Col, Collapse } from "react-bootstrap";
import { useState, useRef, useEffect } from "react";
import styles from "./ResourcesPage.module.css";
import "./HomePage.css";
import { useLang } from "../LangContext";
import { useTheme } from "../ThemeContext";
import MinorHeader from "./MinorHeader";
import { motion, AnimatePresence } from "framer-motion";

export default function ResourcesPage({ windowSize }) {
  const { lang, changeLang, t } = useLang();
  const { s, toggleTheme } = useTheme();
  const [currentText, setCurrentText] = useState("Ресурсы бренда");
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsAnimating(true);
      setTimeout(() => {
        setCurrentText((prev) =>
          prev === "Ресурсы бренда" ? "Спасибо что вы с нами" : "Ресурсы бренда"
        );
        setIsAnimating(false);
      }, 100); // Время анимации
    }, 5000); // Интервал между сменами текста

    return () => clearInterval(interval);
  }, []);

  const variants = {
    enterFromTop: {
      y: -40,
      opacity: 0,
    },
    enterFromBottom: {
      y: 40,
      opacity: 0,
    },
    animate: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.3,
        ease: "easeInOut",
      },
    },
    exitUp: {
      y: -40,
      opacity: 0,
      transition: {
        duration: 0.3,
        ease: "easeInOut",
      },
    },
    exitDown: {
      y: 40,
      opacity: 0,
      transition: {
        duration: 0.3,
        ease: "easeInOut",
      },
    },
  };

  return (
    <>
      <div className={styles.mainBanner} style={s.RMainBanner}>
        <div
          style={{
            position: "relative",
            height: windowSize.isXs ? "100px" : "clamp(60px, 8vw, 80px)",
            overflow: "hidden",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <AnimatePresence mode="wait">
            {currentText === "Ресурсы бренда" ? (
              <motion.h4
                key="resources"
                style={{
                  color: s.logoColor || "#222525",
                  margin: 0,
                  position: "absolute",
                  width: "100%",
                  textAlign: "center",
                  fontFamily: '"Gilroy-semibold", sans-serif',
                  fontSize: "clamp(48px, 7vw, 64px)",
                  lineHeight: 1,
                }}
                initial="enterFromTop"
                animate="animate"
                exit="exitUp"
                variants={variants}
              >
                {t("RMainBanner1")}
              </motion.h4>
            ) : (
              <motion.div
                key="thanks"
                style={{
                  position: "absolute",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                initial="enterFromBottom"
                animate="animate"
                exit="exitDown"
                variants={variants}
              >
                <h4
                  style={{
                    color: s.logoColor || "#222525",
                    margin: 0,
                    fontFamily: '"Gilroy-semibold", sans-serif',
                    fontSize: "clamp(48px, 7vw, 64px)",
                    lineHeight: 1.1,
                    display: "inline",
                    textAlign: "center",
                  }}
                >
                  {t("RMainBanner2")}
                  <svg
                    width="56"
                    height="88"
                    viewBox="0 0 56 88"
                    style={{
                      height: "clamp(60px, 7vw, 81px)",
                      width: "auto",
                      verticalAlign: "middle",
                      display: "inline-block",
                      marginLeft: "10px",
                    }}
                    fill="none"
                  >
                    <path
                      d="M36.7446 66.1654C15.9113 42.1654 -14.5735 -2.03463 15.8265 5.16537C46.2265 12.3654 23.7701 26.4176 33.3267 23.6654C40.7282 21.5338 24.9267 -6.93464 43.3267 6.66536C61.7267 20.2654 47.9934 64.332 38.8267 84.6654"
                      stroke="#23C1FF"
                      strokeWidth="6"
                      strokeLinecap="round"
                    />
                  </svg>
                </h4>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
        {/* <h4 style={{ color: s.logoColor }}>{t("RMainBanner")}</h4> */}
      </div>

      <div
        className={`${styles.resourcesContainer} mt-4`}
        style={s.RMainBanner}
      >
        <Row className="h-100 g-5" xs={1} lg={2} xxl={3}>
          <Col>
            <Row className={`${styles.resourcesSection} gy-3`} xs={1} sm={2}>
              <Col
                style={{ display: "flex", flexDirection: "column" }}
                className="align-items-center"
              >
                <div className="w-100 align-items-left">
                  <h6 style={{ color: s.logoColor }}>{t("RMinorHeader1")}</h6>
                </div>
                <div className={styles.logoContainer} style={s.RLogoBorder}>
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="113"
                    height="85"
                    viewBox="0 0 113 85"
                    fill="none"
                    className={styles.logoIcon}
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M57.8011 42.7989C63.2867 42.6157 67.985 41.3699 71.896 39.0617C76.1727 36.5375 78.2975 33.5238 78.2705 30.0205C78.2717 26.5007 76.1487 23.4874 71.9018 20.9809C67.6548 18.4743 62.5494 17.2213 56.5856 17.222C50.65 17.206 45.5438 18.4601 41.2671 20.9843C36.9903 23.5084 34.8514 26.5304 34.8503 30.0503C34.9054 33.5702 37.0424 36.5751 41.2613 39.0651C44.0176 40.6919 47.3648 41.8205 51.303 42.451L51.2173 46.3361L57.7155 46.5346L57.8011 42.7989ZM51.3887 38.3168C49.3071 37.8522 47.507 37.1716 45.9882 36.2752C43.0631 34.5488 41.6009 32.4902 41.6017 30.0994C41.6025 27.7085 43.1082 25.6246 46.1187 23.8478C49.1293 22.0709 52.6601 21.1822 56.7109 21.1818C60.7618 21.1813 64.2498 22.0443 67.1749 23.7707C70.0999 25.4971 71.5621 27.5557 71.5613 29.9466C71.5605 32.3374 70.0549 34.4213 67.0443 36.1982C64.4839 37.7093 61.4314 38.5813 57.8868 38.8142L58.0155 32.065L51.5173 31.8665L51.3887 38.3168Z"
                      fill="white"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M64.4453 1.94767C60.049 -0.648671 52.9186 -0.649304 48.521 1.94625L3.29755 28.6377C1.09447 29.938 -0.0047117 31.6431 1.51802e-05 33.3473L0.00938617 51.6285C-0.00760194 53.3421 1.09152 55.0589 3.30675 56.3663L48.5233 83.0537C52.9201 85.6487 60.0486 85.6488 64.4453 83.0537L109.662 56.3663C111.915 55.0768 113.014 53.3759 113 51.673L112.953 33.3473C112.954 31.6469 111.855 29.9463 109.657 28.6486L64.4453 1.94767ZM64.1459 3.81459C59.7521 1.21979 52.626 1.21916 48.2309 3.81317L8.91474 27.0178C4.52059 29.6113 4.52059 33.8161 8.91475 36.4096L48.2333 59.6156C52.6274 62.2091 59.7517 62.2091 64.1459 59.6156L103.45 36.418C107.843 33.8251 107.844 29.6214 103.453 27.0277L64.1459 3.81459Z"
                      fill="white"
                    />
                  </svg>
                  <div className={styles.picDownloadBtns}>
                    <div className="d-flex" style={{ position: "relative" }}>
                      <a
                        href="/img/qwins_icon.png"
                        download
                        style={{ textDecoration: "none" }}
                      >
                        <div
                          className={styles.picDownloadContainerLogo}
                          style={{ marginRight: "6px" }}
                        >
                          PNG
                        </div>
                      </a>
                      <a
                        href="/img/qwins_icon.svg"
                        download
                        style={{ textDecoration: "none" }}
                      >
                        <div className={styles.picDownloadContainerLogo}>
                          SVG
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </Col>
              <Col
                style={{ display: "flex", flexDirection: "column" }}
                className="align-items-center"
              >
                <div
                  className={styles.logoContainer}
                  style={{ background: "#23C1FF" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="113"
                    height="85"
                    viewBox="0 0 113 85"
                    fill="none"
                    className={styles.logoIcon}
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M57.8011 42.7989C63.2867 42.6157 67.985 41.3699 71.896 39.0617C76.1727 36.5375 78.2975 33.5238 78.2705 30.0205C78.2717 26.5007 76.1487 23.4874 71.9018 20.9809C67.6548 18.4743 62.5494 17.2213 56.5856 17.222C50.65 17.206 45.5438 18.4601 41.2671 20.9843C36.9903 23.5084 34.8514 26.5304 34.8503 30.0503C34.9054 33.5702 37.0424 36.5751 41.2613 39.0651C44.0176 40.6919 47.3648 41.8205 51.303 42.451L51.2173 46.3361L57.7155 46.5346L57.8011 42.7989ZM51.3887 38.3168C49.3071 37.8522 47.507 37.1716 45.9882 36.2752C43.0631 34.5488 41.6009 32.4902 41.6017 30.0994C41.6025 27.7085 43.1082 25.6246 46.1187 23.8478C49.1293 22.0709 52.6601 21.1822 56.7109 21.1818C60.7618 21.1813 64.2498 22.0443 67.1749 23.7707C70.0999 25.4971 71.5621 27.5557 71.5613 29.9466C71.5605 32.3374 70.0549 34.4213 67.0443 36.1982C64.4839 37.7093 61.4314 38.5813 57.8868 38.8142L58.0155 32.065L51.5173 31.8665L51.3887 38.3168Z"
                      fill="white"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M64.4453 1.94767C60.049 -0.648671 52.9186 -0.649304 48.521 1.94625L3.29755 28.6377C1.09447 29.938 -0.0047117 31.6431 1.51802e-05 33.3473L0.00938617 51.6285C-0.00760194 53.3421 1.09152 55.0589 3.30675 56.3663L48.5233 83.0537C52.9201 85.6487 60.0486 85.6488 64.4453 83.0537L109.662 56.3663C111.915 55.0768 113.014 53.3759 113 51.673L112.953 33.3473C112.954 31.6469 111.855 29.9463 109.657 28.6486L64.4453 1.94767ZM64.1459 3.81459C59.7521 1.21979 52.626 1.21916 48.2309 3.81317L8.91474 27.0178C4.52059 29.6113 4.52059 33.8161 8.91475 36.4096L48.2333 59.6156C52.6274 62.2091 59.7517 62.2091 64.1459 59.6156L103.45 36.418C107.843 33.8251 107.844 29.6214 103.453 27.0277L64.1459 3.81459Z"
                      fill="white"
                    />
                  </svg>
                  <div className={styles.picDownloadBtns}>
                    <div className="d-flex" style={{ position: "relative" }}>
                      <a
                        href="/img/qwins_icon_colored.png"
                        download
                        style={{ textDecoration: "none" }}
                      >
                        <div
                          className={styles.picDownloadContainerLogo}
                          style={{ marginRight: "6px" }}
                        >
                          PNG
                        </div>
                      </a>
                      <a
                        href="/img/qwins_icon_colored.svg"
                        download
                        style={{ textDecoration: "none" }}
                      >
                        <div className={styles.picDownloadContainerLogo}>
                          SVG
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
          <Col>
            <div className={styles.resourcesSection}>
              <Row className="g-0">
                <h6 style={{ color: s.logoColor }}>{t("RMinorHeader2")}</h6>
                <Col style={{ display: "flex", flexDirection: "column" }}>
                  <div className={styles.colorsContainer}>
                    <div className={styles.colorsHalf}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="68"
                        height="68"
                        viewBox="0 0 68 68"
                        fill="none"
                      >
                        <circle cx="34" cy="34" r="34" fill="#222525" />
                      </svg>
                      <div style={{ marginLeft: "16px" }}>
                        <h6>
                          HEX:{" "}
                          <span style={{ color: s.logoColor }}>222525</span>
                        </h6>
                        <h6>
                          RGB:{" "}
                          <span style={{ color: s.logoColor }}>34 37 37</span>
                        </h6>
                        <h6>
                          CSS:{" "}
                          <span style={{ color: s.logoColor }}>
                            rgba(34, 37, 37, 1)
                          </span>
                        </h6>
                      </div>
                    </div>
                    <div className={styles.divider} style={s.RDivider}></div>
                    <div
                      className={styles.colorsHalf}
                      style={{ marginTop: "auto" }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="68"
                        height="68"
                        viewBox="0 0 68 68"
                        fill="none"
                      >
                        <circle cx="34" cy="34" r="34" fill="#23C1FF" />
                      </svg>
                      <div style={{ marginLeft: "16px" }}>
                        <h6>
                          HEX:{" "}
                          <span style={{ color: s.logoColor }}>23C1FF</span>
                        </h6>
                        <h6>
                          RGB:{" "}
                          <span style={{ color: s.logoColor }}>35 193 255</span>
                        </h6>
                        <h6>
                          CSS:{" "}
                          <span style={{ color: s.logoColor }}>
                            rgba(35, 193, 255, 1)
                          </span>
                        </h6>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xs="auto">
                  {!windowSize.isXs && (
                    <div className={styles.rightStick} style={s.RDivider}></div>
                  )}
                </Col>
              </Row>
            </div>
          </Col>
          <Col>
            <div className={styles.resourcesSection}>
              <Row className="g-0">
                <h6 style={{ color: s.logoColor }}>{t("RMinorHeader3")}</h6>
                <Col style={{ display: "flex", flexDirection: "column" }}>
                  <div className={styles.colorsContainer}>
                    <div className={styles.logoHalf} style={s.RLogoBorder}>
                      <Row className="w-100 flex-grow-1">
                        <Col className="d-flex justify-content-start align-items-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="146"
                            height="40"
                            viewBox="0 0 146 40"
                            fill="none"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M84.8902 19.6658C84.8902 21.878 84.1345 23.8037 82.6232 25.443L84.4467 27.2573L82.4507 29L80.5532 27.1141C79.0911 27.9257 77.5551 28.3316 75.9451 28.3316C73.4809 28.3316 71.3699 27.496 69.6121 25.8249C67.8707 24.1379 67 22.0849 67 19.6658C67 17.2467 67.8707 15.2016 69.6121 13.5305C71.3535 11.8435 73.4645 11 75.9451 11C78.4258 11 80.5368 11.8435 82.2782 13.5305C84.0196 15.2016 84.8902 17.2467 84.8902 19.6658ZM75.9451 25.6578C76.8322 25.6578 77.6947 25.4748 78.5326 25.1088L75.3784 21.9814L77.3744 20.2387L80.6764 23.5093C81.5964 22.3952 82.0564 21.1141 82.0564 19.6658C82.0564 17.9629 81.465 16.5385 80.2821 15.3926C79.0993 14.2467 77.6536 13.6737 75.9451 13.6737C74.2366 13.6737 72.7909 14.2467 71.6081 15.3926C70.4253 16.5385 69.8339 17.9629 69.8339 19.6658C69.8339 21.3687 70.4253 22.7931 71.6081 23.939C72.7909 25.0849 74.2366 25.6578 75.9451 25.6578Z"
                              fill="white"
                            />
                            <path
                              d="M97.4456 15.8223L93.7739 28.0212H90.4965L85.6174 11.3103H88.5991L92.2215 24.3687L96.1396 11.3103H98.7517L102.645 24.3687L106.268 11.3103H109.249L104.37 28.0212H101.093L97.4456 15.8223Z"
                              fill="white"
                            />
                            <path
                              d="M119.966 11.3103L128.098 22.6499V11.3103H130.932V28.0212H128.714L120.582 16.6817V28.0212H117.749V11.3103H119.966Z"
                              fill="white"
                            />
                            <path
                              d="M135.64 27.2573C136.806 27.9735 138.219 28.3316 139.878 28.3316C141.718 28.3316 143.188 27.8939 144.289 27.0186C145.423 26.1273 145.989 24.9257 145.989 23.4138C146.088 22.0928 145.497 20.9469 144.215 19.9761C143.903 19.7374 143.484 19.5146 142.958 19.3077C142.318 19.0531 141.891 18.8939 141.677 18.8302C141.546 18.7825 141.069 18.6233 140.248 18.3528C138.917 17.9549 138.005 17.5809 137.513 17.2308C137.02 16.8647 136.773 16.3714 136.773 15.7507C136.773 15.1141 137.02 14.6127 137.513 14.2467C138.005 13.8647 138.662 13.6737 139.484 13.6737C141.176 13.6737 142.383 14.4536 143.106 16.0133L145.497 14.6764C144.938 13.5146 144.133 12.6154 143.082 11.9788C142.047 11.3263 140.847 11 139.484 11C137.94 11 136.634 11.4377 135.566 12.313C134.482 13.1724 133.939 14.3422 133.939 15.8223C133.939 17.3024 134.498 18.4244 135.615 19.1883C136.535 19.7772 137.743 20.2865 139.237 20.7162C140.7 21.1459 141.718 21.5438 142.293 21.9098C142.868 22.2759 143.156 22.7931 143.156 23.4615C143.156 24.13 142.885 24.6631 142.342 25.061C141.8 25.4589 141.003 25.6578 139.952 25.6578C137.784 25.6578 136.354 24.7188 135.664 22.8408L133.225 24.2255C133.685 25.5146 134.49 26.5252 135.64 27.2573Z"
                              fill="white"
                            />
                            <path
                              d="M114.301 11.3103H111.468V28.0212H114.301V11.3103Z"
                              fill="white"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M27.3557 20.1407C29.9519 20.0544 32.1755 19.4682 34.0264 18.382C36.0505 17.1941 37.0561 15.7759 37.0433 14.1273C37.0439 12.4709 36.0391 11.0529 34.0292 9.87334C32.0192 8.69377 29.6029 8.10413 26.7804 8.10445C23.9713 8.09695 21.5546 8.68712 19.5306 9.87495C17.5065 11.0628 16.4942 12.4849 16.4937 14.1413C16.5198 15.7977 17.5312 17.2118 19.5278 18.3836C20.8323 19.1491 22.4165 19.6802 24.2803 19.9769L24.2398 21.8052L27.3152 21.8987L27.3557 20.1407ZM24.3209 18.0314C23.3357 17.8128 22.4838 17.4925 21.765 17.0707C20.3806 16.2583 19.6886 15.2895 19.689 14.1644C19.6893 13.0393 20.4019 12.0587 21.8268 11.2225C23.2516 10.3863 24.9226 9.96811 26.8398 9.9679C28.7569 9.96769 30.4077 10.3738 31.792 11.1862C33.1764 11.9986 33.8684 12.9674 33.868 14.0925C33.8677 15.2176 33.1551 16.1983 31.7302 17.0344C30.5185 17.7456 29.0738 18.1559 27.3963 18.2655L27.4572 15.0894L24.3818 14.996L24.3209 18.0314Z"
                              fill="white"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M30.5002 0.916551C28.4196 -0.305257 25.045 -0.305555 22.9637 0.915884L1.56064 13.4766C0.517983 14.0885 -0.00222992 14.8909 7.18438e-06 15.6928L0.00444222 24.2958C-0.00359779 25.1022 0.516587 25.9101 1.56499 26.5253L22.9648 39.0841C25.0456 40.3053 28.4194 40.3053 30.5002 39.0841L51.9 26.5253C52.9661 25.9185 53.4863 25.1181 53.4798 24.3167L53.4576 15.6928C53.4579 14.8927 52.9379 14.0924 51.8979 13.4817L30.5002 0.916551ZM30.3585 1.7951C28.2791 0.574021 24.9064 0.573723 22.8264 1.79443L4.21911 12.7143C2.13947 13.9347 2.13948 15.9135 4.21911 17.1339L22.8275 28.0544C24.9071 29.2749 28.2789 29.2749 30.3585 28.0544L48.9602 17.1379C51.0393 15.9177 51.0399 13.9395 48.9613 12.7189L30.3585 1.7951Z"
                              fill="white"
                            />
                          </svg>
                        </Col>
                        <Col className="d-flex flex-column align-items-end justify-content-center">
                          <a
                            href="/img/qwins_logo.png"
                            download
                            style={{ textDecoration: "none" }}
                          >
                            <div className={styles.picDownloadContainer}>
                              PNG
                            </div>
                          </a>
                          <a
                            href="/img/qwins_logo.svg"
                            download
                            style={{ textDecoration: "none" }}
                          >
                            <div
                              className={`${styles.picDownloadContainer} mt-2`}
                            >
                              SVG
                            </div>
                          </a>
                        </Col>
                      </Row>
                    </div>
                    <div
                      className={styles.logoHalf}
                      style={{ marginTop: "auto", background: "#23C1FF" }}
                    >
                      <Row className="w-100 flex-grow-1">
                        <Col className="d-flex justify-content-start align-items-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="146"
                            height="40"
                            viewBox="0 0 146 40"
                            fill="none"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M84.8902 19.6658C84.8902 21.878 84.1345 23.8037 82.6232 25.443L84.4467 27.2573L82.4507 29L80.5532 27.1141C79.0911 27.9257 77.5551 28.3316 75.9451 28.3316C73.4809 28.3316 71.3699 27.496 69.6121 25.8249C67.8707 24.1379 67 22.0849 67 19.6658C67 17.2467 67.8707 15.2016 69.6121 13.5305C71.3535 11.8435 73.4645 11 75.9451 11C78.4258 11 80.5368 11.8435 82.2782 13.5305C84.0196 15.2016 84.8902 17.2467 84.8902 19.6658ZM75.9451 25.6578C76.8322 25.6578 77.6947 25.4748 78.5326 25.1088L75.3784 21.9814L77.3744 20.2387L80.6764 23.5093C81.5964 22.3952 82.0564 21.1141 82.0564 19.6658C82.0564 17.9629 81.465 16.5385 80.2821 15.3926C79.0993 14.2467 77.6536 13.6737 75.9451 13.6737C74.2366 13.6737 72.7909 14.2467 71.6081 15.3926C70.4253 16.5385 69.8339 17.9629 69.8339 19.6658C69.8339 21.3687 70.4253 22.7931 71.6081 23.939C72.7909 25.0849 74.2366 25.6578 75.9451 25.6578Z"
                              fill="white"
                            />
                            <path
                              d="M97.4456 15.8223L93.7739 28.0212H90.4965L85.6174 11.3103H88.5991L92.2215 24.3687L96.1396 11.3103H98.7517L102.645 24.3687L106.268 11.3103H109.249L104.37 28.0212H101.093L97.4456 15.8223Z"
                              fill="white"
                            />
                            <path
                              d="M119.966 11.3103L128.098 22.6499V11.3103H130.932V28.0212H128.714L120.582 16.6817V28.0212H117.749V11.3103H119.966Z"
                              fill="white"
                            />
                            <path
                              d="M135.64 27.2573C136.806 27.9735 138.219 28.3316 139.878 28.3316C141.718 28.3316 143.188 27.8939 144.289 27.0186C145.423 26.1273 145.989 24.9257 145.989 23.4138C146.088 22.0928 145.497 20.9469 144.215 19.9761C143.903 19.7374 143.484 19.5146 142.958 19.3077C142.318 19.0531 141.891 18.8939 141.677 18.8302C141.546 18.7825 141.069 18.6233 140.248 18.3528C138.917 17.9549 138.005 17.5809 137.513 17.2308C137.02 16.8647 136.773 16.3714 136.773 15.7507C136.773 15.1141 137.02 14.6127 137.513 14.2467C138.005 13.8647 138.662 13.6737 139.484 13.6737C141.176 13.6737 142.383 14.4536 143.106 16.0133L145.497 14.6764C144.938 13.5146 144.133 12.6154 143.082 11.9788C142.047 11.3263 140.847 11 139.484 11C137.94 11 136.634 11.4377 135.566 12.313C134.482 13.1724 133.939 14.3422 133.939 15.8223C133.939 17.3024 134.498 18.4244 135.615 19.1883C136.535 19.7772 137.743 20.2865 139.237 20.7162C140.7 21.1459 141.718 21.5438 142.293 21.9098C142.868 22.2759 143.156 22.7931 143.156 23.4615C143.156 24.13 142.885 24.6631 142.342 25.061C141.8 25.4589 141.003 25.6578 139.952 25.6578C137.784 25.6578 136.354 24.7188 135.664 22.8408L133.225 24.2255C133.685 25.5146 134.49 26.5252 135.64 27.2573Z"
                              fill="white"
                            />
                            <path
                              d="M114.301 11.3103H111.468V28.0212H114.301V11.3103Z"
                              fill="white"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M27.3557 20.1407C29.9519 20.0544 32.1755 19.4682 34.0264 18.382C36.0505 17.1941 37.0561 15.7759 37.0433 14.1273C37.0439 12.4709 36.0391 11.0529 34.0292 9.87334C32.0192 8.69377 29.6029 8.10413 26.7804 8.10445C23.9713 8.09695 21.5546 8.68712 19.5306 9.87495C17.5065 11.0628 16.4942 12.4849 16.4937 14.1413C16.5198 15.7977 17.5312 17.2118 19.5278 18.3836C20.8323 19.1491 22.4165 19.6802 24.2803 19.9769L24.2398 21.8052L27.3152 21.8987L27.3557 20.1407ZM24.3209 18.0314C23.3357 17.8128 22.4838 17.4925 21.765 17.0707C20.3806 16.2583 19.6886 15.2895 19.689 14.1644C19.6893 13.0393 20.4019 12.0587 21.8268 11.2225C23.2516 10.3863 24.9226 9.96811 26.8398 9.9679C28.7569 9.96769 30.4077 10.3738 31.792 11.1862C33.1764 11.9986 33.8684 12.9674 33.868 14.0925C33.8677 15.2176 33.1551 16.1983 31.7302 17.0344C30.5185 17.7456 29.0738 18.1559 27.3963 18.2655L27.4572 15.0894L24.3818 14.996L24.3209 18.0314Z"
                              fill="white"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M30.5002 0.916551C28.4196 -0.305257 25.045 -0.305555 22.9637 0.915884L1.56064 13.4766C0.517983 14.0885 -0.00222992 14.8909 7.18438e-06 15.6928L0.00444222 24.2958C-0.00359779 25.1022 0.516587 25.9101 1.56499 26.5253L22.9648 39.0841C25.0456 40.3053 28.4194 40.3053 30.5002 39.0841L51.9 26.5253C52.9661 25.9185 53.4863 25.1181 53.4798 24.3167L53.4576 15.6928C53.4579 14.8927 52.9379 14.0924 51.8979 13.4817L30.5002 0.916551ZM30.3585 1.7951C28.2791 0.574021 24.9064 0.573723 22.8264 1.79443L4.21911 12.7143C2.13947 13.9347 2.13948 15.9135 4.21911 17.1339L22.8275 28.0544C24.9071 29.2749 28.2789 29.2749 30.3585 28.0544L48.9602 17.1379C51.0393 15.9177 51.0399 13.9395 48.9613 12.7189L30.3585 1.7951Z"
                              fill="white"
                            />
                          </svg>
                        </Col>
                        <Col className="d-flex flex-column align-items-end justify-content-center">
                          <a
                            href="/img/qwins_logo_colored.svg"
                            download
                            style={{ textDecoration: "none" }}
                          >
                            <div className={styles.picDownloadContainer}>
                              PNG
                            </div>
                          </a>
                          <a
                            href="/img/qwins_logo_colored.svg"
                            download
                            style={{ textDecoration: "none" }}
                          >
                            <div
                              className={`${styles.picDownloadContainer} mt-2`}
                            >
                              SVG
                            </div>
                          </a>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
      <div className="mt-4"></div>
    </>
  );
}
